import { Stack } from "@similarweb/ui-components/foundations";

import { AlertsErrorBoundary } from "../AlertsErrorBoundary";
import { SocialAlertsFilters } from "../social-alerts/filters/SocialAlertsFilters";
import { SocialAlertsFeed } from "../social-alerts/SocialAlertsFeed";
import { SocialMediaMetrics } from "../social-alerts/SocialMediaMetrics";
import type { AlertViewMode } from "../tabs/viewModeConfig";

type SocialPanelProps = {
    viewMode: AlertViewMode;
};

export const SocialPanel = ({ viewMode }: SocialPanelProps) => (
    <Stack
        gap="32px"
        flexGrow={1}
    >
        <SocialAlertsFilters />
        <AlertsErrorBoundary
            alertType="socialMedia"
            viewMode={viewMode}
        >
            {viewMode === "feed" ? <SocialAlertsFeed /> : <SocialMediaMetrics />}
        </AlertsErrorBoundary>
    </Stack>
);
